module.exports = __webpack_public_path__ + "static/portfolio_airbusworld-2066c34e0bd86e6d3d3e1ec72d9c5a1e.png";